export class SharingRequest {
  recipients?: string[];

  constructor(opts?: Partial<SharingRequest>) {
    if (opts?.recipients != null) {
      this.recipients = opts.recipients;
    }
  }
}
